import React from 'react';
import { Check, Crown, Glasses, Zap, Lock, Star, Info } from 'lucide-react';
export const VRSubscription = () => {
  return <div className="space-y-6" data-id="element-22754">
      <div data-id="element-22755">
        <h3 className="text-lg font-medium mb-2" data-id="element-22756">VR/AR Premium Access</h3>
        <p className="text-sm text-gray-400 mb-4" data-id="element-22757">
          Unlock the full potential of immersive experiences with your AI
          companion
        </p>
        <div className="grid grid-cols-2 gap-6" data-id="element-22758">
          <div className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-xl border border-gray-700 overflow-hidden" data-id="element-22759">
            <div className="p-4 border-b border-gray-800" data-id="element-22760">
              <div className="flex items-center gap-2" data-id="element-22761">
                <Glasses size={18} className="text-pink-400" data-id="element-22762" />
                <h3 className="font-bold" data-id="element-22763">VR Basic</h3>
              </div>
              <div className="mt-1 flex items-baseline gap-1" data-id="element-22764">
                <span className="text-2xl font-bold" data-id="element-22765">Free</span>
                <span className="text-sm text-gray-400" data-id="element-22766">with account</span>
              </div>
            </div>
            <div className="p-4 space-y-3" data-id="element-22767">
              <div className="flex items-start gap-2" data-id="element-22768">
                <Check size={16} className="text-pink-400 mt-0.5" data-id="element-22769" />
                <span className="text-sm" data-id="element-22770">3 basic VR environments</span>
              </div>
              <div className="flex items-start gap-2" data-id="element-22771">
                <Check size={16} className="text-pink-400 mt-0.5" data-id="element-22772" />
                <span className="text-sm" data-id="element-22773">Limited AR companion placement</span>
              </div>
              <div className="flex items-start gap-2" data-id="element-22774">
                <Check size={16} className="text-pink-400 mt-0.5" data-id="element-22775" />
                <span className="text-sm" data-id="element-22776">
                  Basic interactions with companion
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-22777">
                <Check size={16} className="text-pink-400 mt-0.5" data-id="element-22778" />
                <span className="text-sm" data-id="element-22779">Standard graphics quality</span>
              </div>
              <div className="flex items-start gap-2 opacity-50" data-id="element-22780">
                <Lock size={16} className="text-gray-400 mt-0.5" data-id="element-22781" />
                <span className="text-sm" data-id="element-22782">Full body tracking</span>
              </div>
              <div className="flex items-start gap-2 opacity-50" data-id="element-22783">
                <Lock size={16} className="text-gray-400 mt-0.5" data-id="element-22784" />
                <span className="text-sm" data-id="element-22785">Advanced haptic feedback</span>
              </div>
              <button className="w-full py-2 mt-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white font-medium" data-id="element-22786">
                Current Plan
              </button>
            </div>
          </div>
          <div className="bg-gradient-to-b from-purple-900/30 to-gray-900 rounded-xl border border-purple-500/50 overflow-hidden relative" data-id="element-22787">
            <div className="absolute top-0 right-0 bg-gradient-to-l from-purple-600 to-pink-600 px-3 py-1 text-xs font-medium text-white" data-id="element-22788">
              RECOMMENDED
            </div>
            <div className="p-4 border-b border-gray-800" data-id="element-22789">
              <div className="flex items-center gap-2" data-id="element-22790">
                <Crown size={18} className="text-purple-400" data-id="element-22791" />
                <h3 className="font-bold" data-id="element-22792">VR Premium</h3>
              </div>
              <div className="mt-1 flex items-baseline gap-1" data-id="element-22793">
                <span className="text-2xl font-bold" data-id="element-22794">$14.99</span>
                <span className="text-sm text-gray-400" data-id="element-22795">/month</span>
              </div>
            </div>
            <div className="p-4 space-y-3" data-id="element-22796">
              <div className="flex items-start gap-2" data-id="element-22797">
                <Check size={16} className="text-purple-400 mt-0.5" data-id="element-22798" />
                <span className="text-sm" data-id="element-22799">All Basic features included</span>
              </div>
              <div className="flex items-start gap-2" data-id="element-22800">
                <Check size={16} className="text-purple-400 mt-0.5" data-id="element-22801" />
                <span className="text-sm" data-id="element-22802">Unlimited VR environments</span>
              </div>
              <div className="flex items-start gap-2" data-id="element-22803">
                <Check size={16} className="text-purple-400 mt-0.5" data-id="element-22804" />
                <span className="text-sm" data-id="element-22805">
                  Full body tracking compatibility
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-22806">
                <Check size={16} className="text-purple-400 mt-0.5" data-id="element-22807" />
                <span className="text-sm" data-id="element-22808">
                  Advanced haptic feedback support
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-22809">
                <Check size={16} className="text-purple-400 mt-0.5" data-id="element-22810" />
                <span className="text-sm" data-id="element-22811">Ultra-realistic graphics</span>
              </div>
              <div className="flex items-start gap-2" data-id="element-22812">
                <Check size={16} className="text-purple-400 mt-0.5" data-id="element-22813" />
                <span className="text-sm" data-id="element-22814">Exclusive VR/AR scenarios</span>
              </div>
              <button className="w-full py-2 mt-2 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg text-white font-medium" data-id="element-22815">
                Upgrade Now
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-800 rounded-lg p-4 border border-gray-700" data-id="element-22816">
        <h3 className="text-lg font-medium mb-4" data-id="element-22817">
          Premium Features Comparison
        </h3>
        <div className="space-y-3" data-id="element-22818">
          <div className="grid grid-cols-3 gap-2 pb-2 border-b border-gray-700" data-id="element-22819">
            <div className="text-sm font-medium" data-id="element-22820">Feature</div>
            <div className="text-sm font-medium text-center" data-id="element-22821">Basic</div>
            <div className="text-sm font-medium text-center" data-id="element-22822">Premium</div>
          </div>
          <div className="grid grid-cols-3 gap-2 py-2 border-b border-gray-700" data-id="element-22823">
            <div className="text-sm" data-id="element-22824">VR Environments</div>
            <div className="text-center text-sm" data-id="element-22825">3</div>
            <div className="text-center text-sm" data-id="element-22826">Unlimited</div>
          </div>
          <div className="grid grid-cols-3 gap-2 py-2 border-b border-gray-700" data-id="element-22827">
            <div className="text-sm" data-id="element-22828">Graphics Quality</div>
            <div className="text-center text-sm" data-id="element-22829">Standard</div>
            <div className="text-center text-sm" data-id="element-22830">Ultra HD</div>
          </div>
          <div className="grid grid-cols-3 gap-2 py-2 border-b border-gray-700" data-id="element-22831">
            <div className="text-sm" data-id="element-22832">Haptic Feedback</div>
            <div className="text-center" data-id="element-22833">
              <div className="w-4 h-4 mx-auto rounded-full bg-gray-700 flex items-center justify-center" data-id="element-22834">
                <Lock size={10} className="text-gray-500" data-id="element-22835" />
              </div>
            </div>
            <div className="text-center text-green-400" data-id="element-22836">
              <Check size={16} className="mx-auto" data-id="element-22837" />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-2 py-2 border-b border-gray-700" data-id="element-22838">
            <div className="text-sm" data-id="element-22839">Body Tracking</div>
            <div className="text-center" data-id="element-22840">
              <div className="w-4 h-4 mx-auto rounded-full bg-gray-700 flex items-center justify-center" data-id="element-22841">
                <Lock size={10} className="text-gray-500" data-id="element-22842" />
              </div>
            </div>
            <div className="text-center text-green-400" data-id="element-22843">
              <Check size={16} className="mx-auto" data-id="element-22844" />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-2 py-2 border-b border-gray-700" data-id="element-22845">
            <div className="text-sm" data-id="element-22846">Intimate Scenarios</div>
            <div className="text-center text-sm" data-id="element-22847">Basic</div>
            <div className="text-center text-sm" data-id="element-22848">Advanced</div>
          </div>
          <div className="grid grid-cols-3 gap-2 py-2 border-b border-gray-700" data-id="element-22849">
            <div className="text-sm" data-id="element-22850">Voice Commands</div>
            <div className="text-center text-sm" data-id="element-22851">Limited</div>
            <div className="text-center text-sm" data-id="element-22852">Full Support</div>
          </div>
          <div className="grid grid-cols-3 gap-2 py-2" data-id="element-22853">
            <div className="text-sm" data-id="element-22854">Monthly Exclusive Content</div>
            <div className="text-center" data-id="element-22855">
              <div className="w-4 h-4 mx-auto rounded-full bg-gray-700 flex items-center justify-center" data-id="element-22856">
                <Lock size={10} className="text-gray-500" data-id="element-22857" />
              </div>
            </div>
            <div className="text-center text-green-400" data-id="element-22858">
              <Check size={16} className="mx-auto" data-id="element-22859" />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gradient-to-r from-pink-900/30 to-purple-900/30 rounded-xl border border-pink-800/50 p-4" data-id="element-22860">
        <div className="flex items-center gap-3 mb-4" data-id="element-22861">
          <div className="w-10 h-10 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-22862">
            <Zap size={18} data-id="element-22863" />
          </div>
          <div data-id="element-22864">
            <h3 className="font-medium" data-id="element-22865">Try Premium for 7 Days</h3>
            <p className="text-sm text-gray-300" data-id="element-22866">
              Experience all VR/AR features with a free trial
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3 p-3 bg-gray-800/50 rounded-lg mb-4" data-id="element-22867">
          <Star size={16} className="text-yellow-400" data-id="element-22868" />
          <p className="text-sm" data-id="element-22869">No commitment required, cancel anytime</p>
        </div>
        <div className="flex items-center justify-between" data-id="element-22870">
          <div className="flex items-center gap-1" data-id="element-22871">
            <Info size={14} className="text-gray-400" data-id="element-22872" />
            <span className="text-xs text-gray-400" data-id="element-22873">Credit card required</span>
          </div>
          <button className="px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium" data-id="element-22874">
            Start Free Trial
          </button>
        </div>
      </div>
    </div>;
};